import React from 'react'

import {
  AddressPageType,
  BrandsPageType,
  CouponsPageType,
  ElementsPageType,
  LoginPageType,
  PaymentOffersPageType,
  PaymentsPageType,
  RewardsPageType,
  UIPreviewType
} from 'src/lib/types/uiPreview'

// ** Page Imports
import BrandsPage from './pages/BrandsPage'
import ElementsPage from './pages/ElementsPage'
import LoginPage from './pages/LoginPage'
import CouponsPage from './pages/CouponsPage'
import AddressPage from './pages/AddressPage'
import PaymentsPage from './pages/PaymentsPage'
import RewardsPage from './pages/RewardsPage'
import PaymentOffersPage from './pages/PaymentOffersPage'

const UIPreview: React.FC<UIPreviewType> = ({ pageType, config }) => {
  switch (pageType) {
    case 'BRAND':
      return <BrandsPage {...(config as BrandsPageType)} />
    case 'ELEMENTS':
      return <ElementsPage {...(config as ElementsPageType)} />
    case 'LOGIN':
      return <LoginPage {...(config as LoginPageType)} />
    case 'COUPONS':
      return <CouponsPage {...(config as CouponsPageType)} />
    case 'ADDRESS':
      return <AddressPage {...(config as AddressPageType)} />
    case 'PAYMENT':
      return <PaymentsPage {...(config as PaymentsPageType)} />
    case 'REWARDS':
      return <RewardsPage {...(config as RewardsPageType)} />
    case 'PAYMENT_OFFERS':
      return <PaymentOffersPage {...(config as PaymentOffersPageType)} />
  }
}

export default UIPreview
